(function() { module.exports = window["Raven"]; }());